import React, { Component } from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import styled from "styled-components"
import ScrollBars from "react-custom-scrollbars"
import Tabs from "../../../layout/navigation/Tabs"
import { ExportDetailsShape } from "../../../../state/shapes/CustomReportShapes"

const QuestionSelectionContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  min-height: 300px;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  padding-top: 1em;
  padding-left: 1em;
`

const QuestionListItem = styled.div`
  padding: 2px 0;
  border-bottom: dotted 1px #ccc;
  font-size: 0.9rem;
  &:last-of-type {
    border-bottom: none;
  }
`

const DeleteIcon = styled.span`
  color: #ff6666;
  cursor: pointer;
  padding: 0 2px;
  margin-right: 5px;
`

class CustomReportSelectedQuestions extends Component {
  render() {
    const {
      exportTabs,
      questionRemoved,
      createNewTab,
      deleteTab,
      updateTab,
      activeTab,
      tabClicked,
      questionSelected,
      t
    } = this.props

    const mappedTabs = exportTabs.map(tab => {
      return { id: tab.id, name: tab.name, allowDelete: exportTabs.length > 1 }
    })
    const newTabAdded = () => {
      createNewTab()
    }
    const deleteEvent = tab => {
      deleteTab(tab)
    }
    const updateEvent = tab => {
      updateTab(tab)
    }
    const onDragOver = e => {
      e.preventDefault()
    }
    const onDrop = e => {
      const droppedElement = e.dataTransfer.getData("text/plain")
      const jsonElement = JSON.parse(droppedElement)

      if (jsonElement && jsonElement.length > 0) {
        // A group of questions is being dropped
        const questions = jsonElement
        for (let i = 0; i < questions.length; i++) {
          const element = questions[i]
          questionSelected(element.questionId, element.clientWorkflowStepId, activeTab)
        }

        // Scroll to bottom so the user can see what they've just added
        this.scrollbars.scrollToBottom()
        return
      }

      // An individual question is being dropped
      const question = jsonElement
      questionSelected(question.questionId, question.clientWorkflowStepId, activeTab)

      // Scroll to bottom so the user can see what they've just added
      this.scrollbars.scrollToBottom()
    }

    const currentTab = exportTabs.find(tab => {
      return tab.id === activeTab
    })

    const currentSelectedQuestions = currentTab.selectedQuestions

    return (
      <div>
        <Tabs
          tabDetails={mappedTabs}
          onTabChange={tabClicked}
          activeTab={activeTab}
          addNewTab={newTabAdded}
          updateTab={updateEvent}
          charactersToDisplay={10}
          deleteEvent={deleteEvent}
        />
        <QuestionSelectionContainer
          className="container droppable"
          onDragOver={e => {
            onDragOver(e)
          }}
          onDrop={e => {
            onDrop(e)
          }}
        >
          <ScrollBars
            autoHeight
            autoHeightMin={300}
            ref={c => {
              this.scrollbars = c
            }}
          >
            {currentTab && currentSelectedQuestions && currentSelectedQuestions.length > 0
              ? currentSelectedQuestions.map((q, i) => {
                  const translatedText = t(q.textTranslationIdentifier)
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <QuestionListItem key={`${q.questionId}_${i}`}>
                      <DeleteIcon
                        className="fa fa-minus-circle"
                        title="Delete"
                        onClick={() => questionRemoved(q.questionId, activeTab)}
                      />
                      {translatedText.length > 0 && <span>{translatedText}</span>}
                      {translatedText.length < 1 && (
                        <span>
                          <i>&lt;No Question Text&gt;</i>
                        </span>
                      )}
                    </QuestionListItem>
                  )
                })
              : null}
          </ScrollBars>
        </QuestionSelectionContainer>
      </div>
    )
  }
}

CustomReportSelectedQuestions.propTypes = {
  activeTab: PropTypes.number.isRequired,
  createNewTab: PropTypes.func.isRequired,
  deleteTab: PropTypes.func,
  exportTabs: PropTypes.arrayOf(PropTypes.shape(ExportDetailsShape)).isRequired,
  questionRemoved: PropTypes.func.isRequired,
  questionSelected: PropTypes.func.isRequired,
  tabClicked: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}
export default translate()(CustomReportSelectedQuestions)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportSelectedQuestions.jsx